import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// HERO
const hero = document.getElementById("hero");
if (hero) {
    gsap.to(".hero__content", {
        scrollTrigger: {
            scrub: true
        },
        y: 200,
        scale: .75,
        opacity: 0
    });
    gsap.to(".hero__icon", {
        scrollTrigger: {
            scrub: true
        },
        scale: 2,
        y: -29.5
    });
}

// ABOUT
const about = document.getElementById("about");
if (about) {
    gsap.from("#about .about__content", {
        y: 50,
        opacity: 0,
        scrollTrigger: {
            trigger: ".about__content-wrapper",
            start: 'top bottom',
            end: 'top center',
            scrub: 2,
        }
    });
}


// METHOD
const method = document.getElementById("method");
if (method) {
    gsap.from("#method h2, #method .method__content", {
        y: 50,
        opacity: 0,
        scrollTrigger: {
            trigger: ".method",
            start: 'top bottom',
            end: 'top center',
            scrub: 2,
        }
    });
}

// METHOD LIST
const methodList = document.getElementById("method-list");
if (methodList) {
    gsap.from("#method-list .method-list__method", {
        y: 50,
        opacity: 0,
        scrollTrigger: {
            trigger: ".method-list",
            start: 'top bottom',
            end: 'top center',
            scrub: 2,
        }
    });
}


// CONTACT
const contact = document.getElementById("contact");
if (contact) {
    gsap.from("#contact h2", {
        y: 50,
        opacity: 0,
        scrollTrigger: {
            trigger: "#contact",
            start: 'top bottom',
            end: 'top center',
            scrub: 2,
        }
    });
    gsap.from("#contact .contact", {
        y: 100,
        opacity: 0,
        scrollTrigger: {
            trigger: "#contact",
            start: '30% bottom',
            end: 'top center',
            scrub: 2,
        }
    });
}
